import { EmailField } from '@hb/shared'
import { forwardRef } from 'react'
import { InputElement, InputProps } from '../../../../../types/fields'
import { useInputPlaceholder } from '../../hooks'
import InputContainer from '../../Shared/InputContainer'
import { TextInputElement } from '../styles'

const EmailInput: InputElement<EmailField> = forwardRef<HTMLInputElement, InputProps<EmailField>>(
  (props, ref) => {
    const { input, field, disabled, readOnly, size } = props
    const inputPlaceholder = useInputPlaceholder(field)

    return (
      <InputContainer {...props}>
        <TextInputElement
          ref={ref}
          disabled={disabled}
          readOnly={readOnly}
          size={size ?? field?.size}
          placeholder={inputPlaceholder}
          autoComplete={field.autocomplete}
          {...input}
        />
      </InputContainer>
    )
  },
)

export default EmailInput
